import React from "react";

const InitialNodeContent = () => {
  return (
    <div className="chatbot-node-container bg-initial-step w-60 px-5 pt-0 pb-5">
      <div className="px-2">
        <div className="d-flex flex-column">
          <div>
            <i className="fa fa-arrow-down fz-10 mr-5" />
            <span className="fz-10 font-700">Mensaje de entrada</span>
          </div>
          <span className="fz-7">Se activa cuando recibimos un texto que contiene un mensaje específico de un cliente.</span>
        </div>
      </div>
    </div>
  )
}

export default InitialNodeContent;
